import React from 'react';
import { Box, Typography } from '@mui/material';
import { capitalizeFirstLetter } from '../utils/capitalize';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../hooks/useTheme';

interface DisplayBoxProps {
    text: string | number;
    unit?: string;
    size?: 'small' | 'medium' | 'large';
    color?: 'textPrimary' | 'textSecondary';
    disabled?: boolean;
    width?: number | string;
}

const DisplayBox: React.FC<DisplayBoxProps> = ({ text, unit, size = 'small', color = 'textPrimary', disabled = false, width = 'auto' }) => {
    const { muiTheme } = useTheme();
    const height = size === 'small' ? 25 : size === 'medium' ? 40 : 48;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                p: '5px',

            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    overflow: 'hidden',
                    width,
                    height,
                    minWidth: 140,
                }}
            >
                <Typography
                    variant="body2"
                    color="success"
                    sx={{
                        fontSize: 12,
                        userSelect: 'none',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {text}
                    {unit && (
                        <Typography
                            component="span"
                            sx={{
                                fontSize: size === 'small' ? '0.75rem' : size === 'medium' ? '0.875rem' : '1rem',
                                fontWeight: 400,
                                ml: 0.5,
                                color: 'text.primary',
                            }}
                        >
                            {capitalizeFirstLetter(unit)}
                        </Typography>
                    )}
                </Typography>
            </Box>
        </Box>
    );
};

export default DisplayBox;
